// import Profile from "../images/Abu Azhar.jpg";
import {
  AiFillGithub,
  AiFillInstagram,
  AiFillLinkedin,
  AiFillTwitterCircle,
} from "react-icons/ai";
import "../Css/home.css";
import Image from "../components/Image";
import resume from "../images/Azhar-resume.pdf";
import { imges } from "../json/data";
export default function Home() {
  return (
    <>
      <div className="home">
        {imges.slice(0, 1).map((pic, i) => {
          return <Image key={i} pictures={pic.img} />;
        })}
        <div className="right-header">
          <div className="name-header-container">
            <span className="top-text">HELLO THERE</span>
            <h1>I'M ABU AZHAR</h1>
            <span className="developer">FRONT END DEVELOPER</span>
            <a href={resume} download="Resume">
              <button>DOWNLOAD CV</button>
            </a>
          </div>
          <div className="social-icons">
            <a href="https://www.linkedin.com/in/abu-azhar-a41288227/">
              <AiFillLinkedin />
            </a>
            <a href="https://twitter.com/AbuAzhar_">
              <AiFillTwitterCircle />
            </a>
            <a href="https://www.instagram.com/_abu_azhar__/">
              <AiFillInstagram />
            </a>
            <a href="https://github.com/AbuAzhar">
              <AiFillGithub />
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
